import React from "react";
import _ from "lodash";

function InputBoolean({
    permessiAPIutente,
    permessiAPIRichiesti,
    oggettoInteroDaModificare,
    setOggetto,
    setSalvato,
    datoBooleano,
    valoreDatoBooleano,
    classnameSeDato1,
    classnameSeDato0,
    testoSe1,
    testoSe0,
    flexWidth,
    icon1,
    icon0,
    colIcon1,
    colIcon0,
    nonCentrare
}) {
        
    function switchaBoolGenerico(dato, nomeDato) {
        setSalvato(false);
        let value;
        if (dato === 1) {
            value = 0
        } else if (dato === 0 || dato === null) {
            value = 1
        }
        const update = _.set(_.cloneDeep(oggettoInteroDaModificare), nomeDato, value)
        setOggetto(update)
    }
    

    return (
        <div className={flexWidth ? flexWidth : ""}>
            {permessiAPIutente[permessiAPIRichiesti]
                    && valoreDatoBooleano === 1
                    && <div className={"br3 flex items-center pointer pa2 fw5 "+classnameSeDato1+" "+(!nonCentrare && "justify-center")} onClick={(e) => switchaBoolGenerico(valoreDatoBooleano, datoBooleano)}><span className={"material-icons pr2 "+(colIcon1 ? colIcon1 : "")}>{icon1 ? icon1 : "radio_button_checked"}</span>{testoSe1}</div>
                }
                {   !(valoreDatoBooleano)
                    && permessiAPIutente[permessiAPIRichiesti]
                    && <div className={"flex items-center pa2 pointer "+classnameSeDato0+" "+(!nonCentrare && "justify-center")} onClick={(e) => switchaBoolGenerico(valoreDatoBooleano, datoBooleano)}><span className={"material-icons pr2 "+(colIcon0 ? colIcon0 : "scrittaColoreAltScuro")}>{icon0 ? icon0 : "radio_button_unchecked"}</span>{testoSe0}</div>
                }
                {!(permessiAPIutente[permessiAPIRichiesti])
                    && valoreDatoBooleano === 1
                    && <div className={"br3 flex items-center pa2 fw5 "+classnameSeDato1+" "+(!nonCentrare && "justify-center")} ><span className={"material-icons pr2 "+(colIcon1 ? colIcon1 : "")}>{icon1 ? icon1 : "radio_button_checked"}</span>{testoSe1}</div>
                }
        </div>
    )



}

export default InputBoolean;